declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    plausible?: (...args: any[]) => void;
  }
}

export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }

  if (window.plausible) {
    window.plausible(eventName, { props: eventParams });
  }

  if (import.meta.env.DEV) {
    console.log('[Analytics]', eventName, eventParams);
  }
};

export const tracking = {
  startFreeClicked: (source: string) => {
    trackEvent('start_free_clicked', { source });
  },

  seeHowItWorksClicked: () => {
    trackEvent('see_how_it_works_clicked');
  },

  faqOpened: (question: string) => {
    trackEvent('faq_opened', { question });
  },

  pricingPrimaryCTAClicked: () => {
    trackEvent('pricing_primary_cta_clicked');
  },

  signupPageViewed: () => {
    trackEvent('signup_page_viewed');
  },

  signupFormSubmitted: () => {
    trackEvent('signup_form_submitted');
  },

  signupCompleted: () => {
    trackEvent('signup_completed');
  },

  signupError: (errorType: string) => {
    trackEvent('signup_error', { error_type: errorType });
  },

  loginPageViewed: () => {
    trackEvent('login_page_viewed');
  },

  loginCompleted: () => {
    trackEvent('login_completed');
  },

  loginError: (errorType: string) => {
    trackEvent('login_error', { error_type: errorType });
  },

  passwordResetRequested: () => {
    trackEvent('password_reset_requested');
  },

  onboardingStepCompleted: (step: string) => {
    trackEvent('onboarding_step_completed', { step });
  },

  firstJournalEntry: () => {
    trackEvent('first_journal_entry');
  },

  firstCoachSession: () => {
    trackEvent('first_coach_session');
  },

  pricingPageViewed: () => {
    trackEvent('pricing_page_viewed');
  },
};
